import { CuisineType } from '../services/exports/Constants';

const CUISINE_EMOJI_MAP: Record<CuisineType, string> = {
  // Top/General
  [CuisineType.Pizza]: '🍕',
  [CuisineType.Burgers]: '🍔',
  [CuisineType.ChickenFried]: '🍗',
  [CuisineType.Wings]: '🍗',
  [CuisineType.KebabDoner]: '🥙',
  [CuisineType.Sandwiches]: '🥪',
  [CuisineType.Wraps]: '🌯',
  [CuisineType.Salads]: '🥗',
  [CuisineType.Healthy]: '🥗',
  [CuisineType.Bowls]: '🍱',
  [CuisineType.Vegan]: '🌱',
  [CuisineType.Vegetarian]: '🥬',
  [CuisineType.GlutenFree]: '🌾',
  [CuisineType.Halal]: '🍖',

  // Asian & Pacific
  [CuisineType.Sushi]: '🍣',
  [CuisineType.Japanese]: '🍱',
  [CuisineType.Ramen]: '🍜',
  [CuisineType.UdonSoba]: '🍜',
  [CuisineType.Korean]: '🍲',
  [CuisineType.KoreanFriedChicken]: '🍗',
  [CuisineType.Chinese]: '🥡',
  [CuisineType.Sichuan]: '🌶️',
  [CuisineType.CantoneseDimSum]: '🥟',
  [CuisineType.Thai]: '🍛',
  [CuisineType.Vietnamese]: '🍜',
  [CuisineType.Malaysian]: '🍛',
  [CuisineType.Indonesian]: '🍛',
  [CuisineType.Filipino]: '🍛',
  [CuisineType.Poke]: '🍣',
  [CuisineType.HotPot]: '🍲',
  [CuisineType.DumplingsGyozaBao]: '🥟',

  // South Asian
  [CuisineType.Indian]: '🍛',
  [CuisineType.Biryani]: '🍚',
  [CuisineType.Pakistani]: '🍛',
  [CuisineType.SriLankan]: '🍛',
  [CuisineType.Nepalese]: '🥟',

  // Middle East & Mediterranean
  [CuisineType.Turkish]: '🥙',
  [CuisineType.Lebanese]: '🥙',
  [CuisineType.Syrian]: '🥙',
  [CuisineType.Israeli]: '🥙',
  [CuisineType.Egyptian]: '🥙',
  [CuisineType.PersianIranian]: '🍖',
  [CuisineType.Iraqi]: '🥙',
  [CuisineType.Afghan]: '🥙',
  [CuisineType.ShawarmaFalafel]: '🥙',
  [CuisineType.MezzeGrill]: '🍢',
  [CuisineType.Greek]: '🥙',
  [CuisineType.Mediterranean]: '🫒',

  // Europe
  [CuisineType.Italian]: '🍝',
  [CuisineType.Pasta]: '🍝',
  [CuisineType.French]: '🥖',
  [CuisineType.SpanishTapas]: '🥘',
  [CuisineType.Portuguese]: '🐟',
  [CuisineType.German]: '🥨',
  [CuisineType.Austrian]: '🥨',
  [CuisineType.Balkan]: '🍖',
  [CuisineType.Hungarian]: '🌶️',
  [CuisineType.Polish]: '🥟',
  [CuisineType.Czech]: '🍺',
  [CuisineType.Georgian]: '🥟',

  // Americas
  [CuisineType.Mexican]: '🌮',
  [CuisineType.TexMex]: '🌯',
  [CuisineType.Peruvian]: '🍤',
  [CuisineType.Brazilian]: '🥩',
  [CuisineType.Argentinian]: '🥩',
  [CuisineType.Caribbean]: '🌴',
  [CuisineType.BBQAmerican]: '🍖',
  [CuisineType.Steakhouse]: '🥩',
  [CuisineType.AmericanGeneral]: '🍔',
  [CuisineType.HotDogs]: '🌭',

  // Seafood & Specialty
  [CuisineType.Seafood]: '🦐',
  [CuisineType.FishAndChips]: '🍟',
  [CuisineType.SteamedFish]: '🐟',

  // Breakfast, Bakery & Sweets
  [CuisineType.BreakfastBrunch]: '🥞',
  [CuisineType.Bagels]: '🥯',
  [CuisineType.Bakery]: '🥐',
  [CuisineType.PastryDessert]: '🧁',
  [CuisineType.WafflesCrepes]: '🧇',
  [CuisineType.IceCreamGelato]: '🍦',
  [CuisineType.Donuts]: '🍩',
  [CuisineType.Cakes]: '🍰',

  // Beverage-led
  [CuisineType.CoffeeCafe]: '☕',
  [CuisineType.BubbleTea]: '🧋',
  [CuisineType.JuiceSmoothies]: '🥤',
  [CuisineType.Milkshakes]: '🥤',
  [CuisineType.BarPub]: '🍺',
  [CuisineType.WineBar]: '🍷',
  [CuisineType.Cocktails]: '🍸',

  // Other Concepts
  [CuisineType.TapasMezeSmallPlates]: '🍢',
  [CuisineType.Noodles]: '🍜',
  [CuisineType.Soup]: '🍲',
  [CuisineType.Schnitzel]: '🍖',
  [CuisineType.SoulFood]: '🍗',
  [CuisineType.ComfortFood]: '🍲',
  [CuisineType.StreetFood]: '🌭',
  [CuisineType.OrganicBio]: '🌱',
  [CuisineType.KidsMenu]: '🧒',
};

export function getCuisineEmoji(cuisineTypes: CuisineType[] | null | undefined): string | null {
  if (!cuisineTypes?.length) {
    return null;
  }

  return CUISINE_EMOJI_MAP[cuisineTypes[0]] ?? null;
}
